export class BaseClass {
  target;

  constructor(identifier, multi) {
    // console.log('constructor:' + identifier);
    this.target = this.elementExists(identifier, multi);
  }

  /**
   * description
   */
  elementExists = (elementName, multi) => {
    let el;
    // console.log('multi: ' + multi);
    if (!multi) {
      el = document.querySelector(elementName);
    } else {
      el = document.querySelectorAll(elementName);
    }
    // console.log(elementName);
    // console.log(el);
    return !el ? false : el;
  };

  targetExists = () => {
    return !this.target || this.target === undefined ? false : true;
  };

  /**
   * Checks if the dom with is wider than a specified number
   * of pixels.
   *
   * @param {int} width - Number in pixels, defaults to 768
   *
   * @return {bool} True or false value
   */
  isMobile = (width = 768) => {
    return window.innerWidth <= width;
  };
}
